import React ,{useEffect} from "react";
import { MetaTags } from "react-meta-tags";
//import Breadcrumbs
import {
    Breadcrumbs,
    DashBreadcrumb,
  } from "../../components/Common/Breadcrumb";
import Callbacklist from "./components/LsStockSkuList";





import {
    Col,
    Container,
    Row,
    FormGroup, 
    InputGroup, 
  } from "reactstrap";

const LsStockSkuList = () => {
  
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Ls Stock Sku List View</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={6}>
              <DashBreadcrumb title="LsStock" breadcrumbItem="Sku List View" />
            </Col>
       
          </Row>
          
         <Callbacklist/>
         
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LsStockSkuList;
